import PageMeta from "../../components/common/PageMeta";

export default function Privacy() {
  return (
    <>
      <PageMeta
        title="プライバシーポリシー"
        description="ChatoraHack Lotteryのプライバシーポリシーです。"
        path="/privacy"
        breadcrumbs={[
          { name: "TOP", path: "/" },
          { name: "プライバシーポリシー", path: "/privacy" },
        ]}
      />
      <div className="mx-auto mb-8">
        
        <div className="flex justify-between items-center flex-wrap mb-8 border-b border-b-2 border-primary-500 pb-2">
          <h1 className="text-2xl font-bold text-primary-500">
            プライバシーポリシー
          </h1>
        </div>

        <div className="p-8 bg-base-50 rounded-3xl">
          <section className="mb-8">
            <h2 className="text-lg font-bold text-primary-500 mb-4">アクセス解析について</h2>
            <p className="text-gray-800 text-sm leading-relaxed">
              当サイトではGoogle Analyticsを使用しています。Google
              Analyticsはトラフィックデータの収集のためにCookieを使用しています。このデータは匿名で収集されており、個人を特定するものではありません。この機能はCookieを無効にすることで収集を拒否することができます。
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-bold text-primary-500 mb-4">広告について</h2>
            <p className="text-gray-800 text-sm leading-relaxed">
              当サイトではGoogle
              AdSenseおよびアフィリエイト広告を掲載しています。広告配信にはCookieが使用されることがあります。Cookieを無効にする方法や詳細についてはGoogleのポリシーをご確認ください。
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-bold text-primary-500 mb-4">免責事項</h2>
            <p className="text-gray-800 text-sm leading-relaxed">
              当サイトに掲載している情報の正確性には万全を期していますが、その内容を保証するものではありません。当サイトの情報を利用したことによって生じたいかなる損害についても、運営者は責任を負いかねます。
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-bold text-primary-500 mb-4">お問い合わせ</h2>
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSfEAEWstoZZmx_Gyc8JL-uM-8npguBxA1b4Ul5fiqZBTq8v1Q/viewform?usp=header"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-500 underline hover:no-underline text-sm"
            >
              お問い合わせフォーム
            </a>
          </section>
        </div>
      </div>
    </>
  );
}
